import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/hi';
import 'dayjs/locale/id';
import 'dayjs/locale/ko';
import 'dayjs/locale/ms';
import 'dayjs/locale/pt';
import 'dayjs/locale/sw';
import 'dayjs/locale/th';

import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(relativeTime);
export function checkUserTest(address?: string) {
    if (!address) {
        return false;
    }

    return [
        '0x7d2fbcd4932c7d99d825015fa28b7eb7e39ab65d',
        '0x5744c7c3b2825f6478673676015657a9c81594ba',
    ]
        .map((e) => e.toLowerCase())
        .includes(address.toLowerCase());
}

export function formatTime(
    createdAt: string | number | Date,
    lang: string = 'en' // mặc định là tiếng Anh
) {
    const date = dayjs.utc(createdAt).locale(lang); // set locale
    const now = dayjs.utc().locale(lang);

    if (date.isSame(now, 'day')) {
        return date.from(now); // ví dụ: "5 phút trước" nếu lang = 'vi'
    }

    return date.format('YYYY-MM-DD HH:mm');
}
